import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import type { FormControl, FormGroup } from '@angular/forms';

import { formSignalValue } from '@core/common-legacy';
import type { DynamicFormConfig } from '@tellent-ask-hr/dynamic-forms-types';

import { DefineFormWrapperComponent } from '../../partials/define-form-wrapper/define-form-wrapper.component';
import { SingleInputComponent } from '../../partials/single-input/single-input.component';

@Component({
  selector: 'text-single-line',
  imports: [DefineFormWrapperComponent, SingleInputComponent],
  template: `
    <rt-define-form-wrapper
      [defineForm]="defineForm()"
      [respondKindIcon]="defineConfig().icon"
      [respondKindName]="defineConfig().name"
      (duplicate)="duplicate.emit()"
      (delete)="delete.emit()"
      (changeTemplate)="changeTemplate.emit($event)"
    >
      <rt-simple-question
        [defineForm]="defineForm()"
        [isRequired]="defineFormValue().required"
        padding-medium
      />
    </rt-define-form-wrapper>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionComponent {
  public defineConfig = input.required<DynamicFormConfig['defineConfig']>();
  public defineForm = input.required<
    FormGroup<{
      question: FormControl<string>;
      hint: FormControl<string>;
      required: FormControl<boolean>;
    }>
  >();

  public duplicate = output();
  public delete = output();
  public changeTemplate = output<string>();

  protected defineFormValue = formSignalValue(this.defineForm);
}
